module.exports = __webpack_public_path__ + "static/media/dashboard-bill.82f2971f.svg";